import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Button } from '@material-ui/core';
import styles from './ImageUploadButton.css';

const imageURL = '/api/v1/images/';

@inject('formDataStore')
@observer
class ImageUploadButton extends Component {
  ImageUploadHandler(event) {
    this.props.formDataStore.uploadLogo(event.target.files[0]);
  }

  render() {
    return (
      <div>
        <input
          type="file"
          onChange={event => {
            this.ImageUploadHandler(event);
          }}
        />
        <img
          style={styles.imageBox}
          src={imageURL + this.props.formDataStore.customerCase.customer.logo}
          alt={'kuva'}
        />
      </div>
    );
  }
}

export default ImageUploadButton;



// WEBPACK FOOTER //
// ./src/views/CreateNewCase/ImageUploadButton/ImageUploadButton.jsx